import { BrowserModule } from "@angular/platform-browser";
import { NgModule, APP_INITIALIZER } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { AppSharedModule } from "./shared/app-shared.module";
import { PageNotFoundComponent } from "./modules/pagenotfound/page-not-found.component";
import { MasterModule } from "./modules/master/master-module";
import { AppConfig } from "../config/app.config";
import { HttpClientModule } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

@NgModule({
	declarations: [AppComponent, PageNotFoundComponent],
	imports: [BrowserModule, FormsModule, HttpClientModule, AppSharedModule, MasterModule, AppRoutingModule, BrowserAnimationsModule],
	providers: [
		AppConfig,
		{
			provide: APP_INITIALIZER,
			useFactory: ConfigLoader,
			deps: [AppConfig],
			multi: true,
		},
	],
	bootstrap: [AppComponent],
})
export class AppModule {}
export function ConfigLoader(configService: AppConfig) {
	return () => configService.load();
}
